import { agoLabel, formatScore, shortHash } from './utils.js'

export default function ContextStrip({
  dream,
  memories,
  generators,
  evolution,
  evoPopulation,
  onOpenDetail,
}) {
  const mem = dream?.memory
  const top = (evoPopulation?.members || []).slice(0, 3)
  const candCount = generators?.count ?? (generators?.candidates || []).length

  return (
    <div className="mobi-context">
      <button
        type="button"
        className="mobi-context-cell"
        onClick={() => onOpenDetail?.({ kind: 'generator', dream, generators })}
      >
        <span className="dm-section">GENERATOR</span>
        <div className="mobi-context-body">
          <div>{dream?.generator_type || '—'}</div>
          <div className="dm-dim">
            {dream?.generator_family || dream?.mutation_type || 'built-in'}
            {dream?.generator_hash ? ` · ${shortHash(dream.generator_hash)}` : ''}
          </div>
          {dream?.parent_generator_hash && (
            <div className="dm-dim">parent {shortHash(dream.parent_generator_hash)}</div>
          )}
          <div className="dm-dim">{candCount} candidates</div>
        </div>
      </button>

      <button
        type="button"
        className="mobi-context-cell"
        onClick={() => onOpenDetail?.({ kind: 'memory', dream, memories })}
      >
        <span className="dm-section">MEMORY</span>
        <div className="mobi-context-body">
          <div>
            nearest{' '}
            {mem?.nearest_generation != null
              ? `#${mem.nearest_generation}`
              : mem?.nearest_memory_id != null
                ? `#${mem.nearest_memory_id}`
                : '—'}
          </div>
          <div className="dm-dim">
            sim {formatScore(mem?.nearest_similarity)} · LTM {memories?.length ?? 0}
          </div>
        </div>
      </button>

      <button
        type="button"
        className="mobi-context-cell"
        onClick={() =>
          onOpenDetail?.({ kind: 'evolution', evolution, population: evoPopulation })
        }
      >
        <span className="dm-section">EVOLUTION</span>
        <div className="mobi-context-body">
          <div>
            gen {evolution?.current_generation ?? '—'} · pop{' '}
            {evolution?.population_size ?? '—'}
          </div>
          <div className="dm-dim">
            elite {evolution?.elite_count ?? '—'} · {agoLabel(evolution?.last_cycle_at)}
          </div>
          {top[0] && (
            <div className="dm-dim">
              top #{shortHash(top[0].generator_hash)} ·{' '}
              {formatScore(top[0].fitness)}
            </div>
          )}
          {dream?.evolution_generation != null && (
            <div className="dm-dim">dream evo #{dream.evolution_generation}</div>
          )}
        </div>
      </button>
    </div>
  )
}
